import React from 'react';
import { Box, Text } from '../../../ui';
import { currencyFormatter } from '../../../pages/QuotePage/content/QuoteGrids/utils';
import { LayoutBox } from '../../../components';

const LocationDetails = ({ aggregates, location }) => (
  <Box
    sx={{
      padding: '10px',
      minWidth: '220px',
      maxWidth: '300px',
      backgroundColor: 'white',
    }}
  >
    <Box sx={{ marginBottom: '8px' }}>
      <Text
        style={{
          fontWeight: 'bold',
          marginBottom: 8,
          color: '#333',
          textAlign: 'left',
          fontSize: 16,
        }}
      >
        Location Details
      </Text>

      <LayoutBox column gap="4px">
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Customer:
          </Text>
          <Text
            style={{
              fontWeight: 'bold',
              color: '#2d3748',
              fontSize: '14px',
              lineHeight: '1.4',
            }}
          >
            {location.customerName || 'N/A'}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Type:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>{location.attributes?.type || 'N/A'}</Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Risk ID:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>{location.riskId || 'N/A'}</Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Name:
          </Text>
          <Text
            style={{
              fontWeight: '500',
              fontSize: '13px',
              lineHeight: '1.4',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '160px',
              overflow: 'hidden',
              textAlign: 'left',
            }}
          >
            {location.name || 'N/A'}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Address:
          </Text>
          <Text
            style={{
              fontWeight: '500',
              fontSize: '13px',
              lineHeight: '1.4',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '160px',
              overflow: 'hidden',
              textAlign: 'left',
            }}
          >
            {location.address || 'N/A'}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            CSR ID:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>{location.attributes?.csrId || 'N/A'}</Text>
        </LayoutBox>

        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            CRZ ID:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>{location.attributes?.crzId || 'N/A'}</Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Floodzone:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>{location.attributes?.femaFloodZone || 'N/A'}</Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            TIV:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>
            {currencyFormatter({ field: { value: location.coveredValue } })}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            Rate:
          </Text>
          {/* Using boundRate as Rate because in BigQuery ag.rate is bound_rate */}

          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>{location.aggregates?.boundRate || 'N/A'}</Text>
        </LayoutBox>
      </LayoutBox>
    </Box>

    <Box
      sx={{
        border: 'none',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: '#eee',
        margin: '8px 0',
      }}
    />

    <Box sx={{ marginBottom: '8px' }}>
      <Text
        style={{
          fontWeight: 'bold',
          marginBottom: '8px',
          color: '#333',
          textAlign: 'left',
          fontSize: '16px',
        }}
      >
        Aggregation Limits
      </Text>
      <LayoutBox column gap="4px">
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            5 Mile Coverage:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>
            {currencyFormatter({ field: { value: aggregates.coverage5mi } })}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            10 Mile Coverage:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>
            {currencyFormatter({ field: { value: aggregates.coverage10mi } })}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            25 Mile Coverage:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>
            {currencyFormatter({ field: { value: aggregates.coverage25mi } })}
          </Text>
        </LayoutBox>
        <LayoutBox row gap="12px">
          <Text
            style={{
              color: '#666',
              minWidth: '100px',
              textAlign: 'left',
              flexShrink: 0,
              fontWeight: 'bold',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            50 Mile Coverage:
          </Text>
          <Text style={{ fontWeight: '500', fontSize: '13px', lineHeight: '1.4' }}>
            {currencyFormatter({ field: { value: aggregates.coverage50mi } })}
          </Text>
        </LayoutBox>
      </LayoutBox>
    </Box>
  </Box>
);

export default LocationDetails;
